import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, IconButton } from '@material-ui/core';

import { DeleteIcon, SuggestAsync, ISuggestProps } from 'components';

const AddUser: FC<Partial<ISuggestProps>> = ({ exclusions, onChange, ...rest }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');

  return (
    <Grid container alignItems="center">
      <Grid item xs>
        <SuggestAsync
          type="profile"
          inputValue={value}
          placeholder={t('components:userSuggest')}
          exclusions={exclusions}
          onChange={onChange}
          onInputChange={inputValue => setValue(inputValue)}
          {...rest}
        />
      </Grid>
      {!!value.length && (
        <Grid item>
          <IconButton onClick={() => setValue('')}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default AddUser;
